import { useEachRecursively } from './useEachRecursively.js'

export function useGetSelectedsRecursively(modules = []) {
	const selecteds = {
		modules: new Set(),
		modalities: new Set(),
		schedules: new Set(),
	}

	useEachRecursively(modules, (item, skip) => {
		if (item.selected) selecteds[item.key].add(item.id)
	})

	return {
		modules: [...selecteds.modules],
		modalities: [...selecteds.modalities],
		schedules: [...selecteds.schedules],
	}
}
